export default "__VITE_ASSET__DmtuEHuC__"